import React from "react";
import {
    useSetWorkspaceBookmarks,
    useSetWorkspaceTracks,
    useWorkspaceBookmarks,
    useWorkspaceTracks
} from "../../../stores/WorkspaceStore";


export function BookmarksBrowser() {
    const tracks = useWorkspaceTracks();
    const setWorkspaceTracks = useSetWorkspaceTracks();
    const projectBookmarks = useWorkspaceBookmarks();
    const setProjectBookmarks = useSetWorkspaceBookmarks();

    return (<div className="bookmarks-browser">
        <ol className='midi-device-panel--list'>

            {projectBookmarks.map((b, idx) => {
                const style = {
                    color: b.color,
                    backgroundColor: b.selected ? 'var(--md-sys-color-outline)' : 'transparent'
                };
                return (<li
                    key={idx}
                    onClick={() => {
                        b.selected = !b.selected;
                        setProjectBookmarks([...projectBookmarks]);
                    }}
                >
                    <span style={style}>■</span> <span style={{ fontWeight: b.selected ? 'bold' : 'normal' }}>{b.note} [{b.scope}:{b.position}]</span>
                </li>);
            })}

            {Array.from(tracks.values())
                .map((t) => t.bookmarks.map((b, idx) => {
                    const style = {
                        color: b.color,
                        backgroundColor: b.selected ? 'var(--md-sys-color-outline)' : 'transparent'
                    };

                    return <li
                        key={idx}
                        onClick={() => {
                            b.selected = !b.selected;
                            setWorkspaceTracks(new Map(tracks));
                        }}
                    >
                        <span style={style}>■</span> {t.name}/<span style={{ fontWeight: b.selected ? 'bold' : 'normal' }}>{b.note} [{b.scope}:{b.position}]</span>
                    </li>
                }))
            }
        </ol>
    </div>);
}